module.exports = __webpack_public_path__ + "static/media/devon.27b08f17.jpg";